import { Brand, CategoryType } from 'api/categories/_requests';
import { ProductDetail } from 'api/products/_requests';
import axios from 'axios';
import { handleRequest } from 'helpers/api';

const SEARCHLOG_URL = `${process.env.REACT_APP_API_URL}/searchLog`;

const searchLogApi = axios.create({
  baseURL: SEARCHLOG_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

export interface AddSearchData {
  userId?: string;
  text: string;
}

export interface ProductSearch {
  _id: string;
  vendorId: string;
  name: string;
  description: string;
}

export interface CategoriesSearch {
  _id?: string;
  name?: string;
  slug?: string;
}

export interface SearchLog {
  term?: string;
  user?: string;
  count?: string;
  lastSearchedAt?: string;
}

export interface SearchData {
  products: ProductDetail[];
  brands: Brand[];
  categories: CategoriesSearch[];
}
export interface SearchDetails {
  topSearch: SearchLog[];
  recentSearch: SearchLog[];
  topCategories: CategoriesSearch[];
}
export interface prodBrandCat {
  id?: string;
  name?: string;
  slug?: string;
  categoryType?: string | null;
}

export interface SearchAddedData {
  status?: boolean;
  type?: string;
  data?: prodBrandCat | null;
}

export const addSearchLog = async (seacrh: AddSearchData) => {
  return handleRequest(
    searchLogApi.post<SearchAddedData>('/addSearchLog', seacrh)
  );
};

export const getOnSearch = async (text: string) => {
  return handleRequest(
    searchLogApi.get<SearchData>(`/onsearch-data?text=${text}`)
  );
};

export const getSearchDetail = async () => {
  return handleRequest(searchLogApi.get<SearchDetails>(`/search-details`));
};
